// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingPromo_base--2PyWa","header":"LandingPromo_header--1JxrW","message":"LandingPromo_message--skw0z","text":"LandingPromo_text--2AFmW","tooltipContainer":"LandingPromo_tooltipContainer--RtpxU","awardMessage":"LandingPromo_awardMessage--1oYyb","buttonWrapper":"LandingPromo_buttonWrapper--2RQwA","glowing":"LandingPromo_glowing--1tW3W"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingPromo/LandingPromo.scss
// module id = 2286
// module chunks = 11